import { ArrowRight, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";

const HERO_IMAGE = "https://images.pexels.com/photos/11408618/pexels-photo-11408618.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export default function HeroSection() {
  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section id="home" className="pt-24 md:pt-32 pb-16 md:pb-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left Content */}
          <div className="space-y-8 animate-fade-in-up">
            <div>
              <p className="text-sm font-bold uppercase tracking-[0.2em] bg-clip-text text-transparent bg-gradient-to-r from-orange-500 via-blue-500 to-purple-500 mb-4">
                Serramenti • Infissi • Porte • Persiane
              </p>
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-[#0B1E36] leading-tight">
                Luce, <span className="gradient-text">Colore</span> e Sicurezza per la Tua Casa
              </h1>
            </div>
            
            <p className="text-lg text-[#64748B] leading-relaxed max-w-xl">
              Da Finestre e Colore trasformiamo la tua casa con serramenti di alta qualità. 
              Finestre, porte finestre, infissi e persiane che uniscono design, 
              efficienza energetica e sicurezza.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                onClick={(e) => scrollToSection(e, "#preventivo")}
                className="btn-shine bg-[#0B1E36] hover:bg-[#0B1E36]/90 text-white font-semibold px-8 py-6 rounded-full text-base flex items-center gap-2 group"
                data-testid="hero-cta-button"
              >
                Richiedi Preventivo Gratuito
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Button>
              
              <a 
                href="tel:+393272823064"
                className="inline-flex items-center justify-center gap-2 border-2 border-[#0B1E36] text-[#0B1E36] font-semibold px-8 py-4 rounded-full hover:bg-[#0B1E36] hover:text-white transition-all duration-300"
                data-testid="hero-phone-button"
              >
                <Phone className="w-5 h-5" />
                Chiamaci Ora
              </a>
            </div>

            {/* Trust badges */}
            <div className="flex flex-wrap gap-6 pt-4">
              <div className="flex items-center gap-2 text-[#64748B]">
                <div className="w-10 h-10 rounded-full bg-[#4CD964]/10 flex items-center justify-center">
                  <svg className="w-5 h-5 text-[#4CD964]" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </div>
                <span className="text-sm font-medium">Preventivo Gratuito</span>
              </div>
              <div className="flex items-center gap-2 text-[#64748B]">
                <div className="w-10 h-10 rounded-full bg-[#007AFF]/10 flex items-center justify-center">
                  <svg className="w-5 h-5 text-[#007AFF]" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </div>
                <span className="text-sm font-medium">Installazione Professionale</span>
              </div>
              <div className="flex items-center gap-2 text-[#64748B]">
                <div className="w-10 h-10 rounded-full bg-[#FF9500]/10 flex items-center justify-center">
                  <svg className="w-5 h-5 text-[#FF9500]" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </div>
                <span className="text-sm font-medium">Garanzia Totale</span>
              </div>
            </div>
          </div>

          {/* Right Image */}
          <div className="hero-image-container animate-fade-in-up animate-delay-200">
            <img 
              src={HERO_IMAGE}
              alt="Soggiorno luminoso con finestre moderne"
              className="w-full h-[400px] md:h-[550px] object-cover rounded-3xl shadow-2xl"
              data-testid="hero-image"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
